import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { GASpotEventState } from '../../organisms/NegotiationCountList';

export interface VisitTabsProps {
  activeTabKey: string;
  tabList: TabProps[];
  onTabClick: (type: string) => void;
  gaSpotEventTabs: { [key: string]: GASpotEventState };
}

export interface TabProps {
  title: string;
  type: string;
  url: string;
}

class VisitTabs extends Component<VisitTabsProps> {
  componentDidMount(): void {
    const { gaSpotEventTabs } = this.props;
    Object.values(gaSpotEventTabs).forEach(({ spotEvent, className }) => {
      document.querySelector(`.${className}`)?.setAttribute('onclick', spotEvent);
    });
  }
  render() {
    const { gaSpotEventTabs } = this.props;
    return (
      <div className='uc-tabs u-ph16'>
        {this.props.tabList.map((row) => (
          <div key={row.type}>
            <Link
              className={classNames(
                'uc-tab',
                gaSpotEventTabs[row.type].className,
                this.props.activeTabKey === row.type && 'uc-tab--active'
              )}
              to={row.url}
              data-testid={`visit-tabs--tab-${row.type}`}
              onClick={() => this.props.onTabClick(row.type)}>
              <span className='uc-tab__label' data-testid='visit-tabs--title'>
                {row.title}
              </span>
              <div className='uc-tab__indicator' />
            </Link>
          </div>
        ))}
      </div>
    );
  }
}

export default VisitTabs;
